var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetamaskCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1071 6L14.8125 11.4201L16.169 8.22587L22.1071 6Z",
    fill: "#E17726"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91016 6.00635L11.8323 8.22624L13.1204 11.4624L5.91016 6.00635Z",
    fill: "#E27625"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1688 17.5271L22.3929 17.5887L21.2661 21.4326L17.332 20.3449L19.1688 17.5271Z",
    fill: "#E27625"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83071 17.5271L10.6607 20.3449L6.7332 21.4327L5.61328 17.5887L8.83071 17.5271Z",
    fill: "#E27625"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9475 10.6381L13.0793 14.9115L9.13672 14.7313L10.2582 13.0324L10.2724 13.016L12.9475 10.6381Z",
    fill: "#E27625"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.012 10.5905L17.728 13.0162L17.7421 13.0325L18.8636 14.7315L14.9219 14.9115L15.012 10.5905Z",
    fill: "#E27625"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7737 17.5396L12.9265 19.2239L10.4258 20.4364L10.7737 17.5396Z",
    fill: "#E27625"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2272 17.5392L17.5679 20.4363L15.0742 19.2237L17.2272 17.5392Z",
    fill: "#E27625"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1289 19.0651L17.6594 20.2955L15.3055 21.419L15.33 20.6764L15.1289 19.0651Z",
    fill: "#D5BFB2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8727 19.0657L12.6795 20.6644L12.6954 21.4181L10.3359 20.2956L12.8727 19.0657Z",
    fill: "#D5BFB2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1409 15.4692L12.8022 16.8648L10.5508 16.2025L12.1409 15.4692Z",
    fill: "#233447"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8603 15.4694L17.4579 16.2025L15.1992 16.8646L15.8603 15.4694Z",
    fill: "#233447"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9473 17.5251L10.5834 20.5286L8.63281 17.5908L10.9473 17.5251Z",
    fill: "#CC6228"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0547 17.5251L19.3692 17.5908L17.4113 20.5287L17.0547 17.5251Z",
    fill: "#CC6228"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9227 14.5615L17.2382 16.2854L15.9396 15.6894L15.3178 17.0021L14.9102 14.7448L18.9227 14.5615Z",
    fill: "#CC6228"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07812 14.5615L13.0913 14.7449L12.6837 17.0021L12.0618 15.6896L10.77 16.2855L9.07812 14.5615Z",
    fill: "#CC6228"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96484 14.2078L10.8706 16.1497L10.9366 18.0668L8.96484 14.2078Z",
    fill: "#E27525"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0378 14.2043L17.0625 18.0703L17.1369 16.1498L19.0378 14.2043Z",
    fill: "#E27525"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9983 14.3259L13.075 14.8107L13.2645 16.0185L13.1427 19.7278L12.5666 16.7481L12.5664 16.7172L12.9983 14.3259Z",
    fill: "#E27525"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9998 14.3193L15.4329 16.7173L15.4327 16.7481L14.8552 19.7354L14.8323 18.9882L14.7422 15.9966L14.9998 14.3193Z",
    fill: "#E27525"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3055 16.0725L17.241 17.7382L15.2306 19.3111L14.8242 19.0227L15.2798 16.6664L17.3055 16.0725Z",
    fill: "#F5841F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6992 16.0725L12.718 16.6664L13.1735 19.0227L12.7671 19.3111L10.7566 17.738L10.6992 16.0725Z",
    fill: "#F5841F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94922 19.9277L12.5213 21.1515L12.5104 20.6289L12.7256 20.4393H15.2712L15.4942 20.6283L15.4778 21.1505L18.0335 19.9308L16.7899 20.9628L15.2861 22H12.705L11.2021 20.9586L9.94922 19.9277Z",
    fill: "#C0AC9D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9447 18.9022L15.3083 19.1602L15.5214 20.8676L15.213 20.6061H12.7908L12.4883 20.8729L12.6944 19.1603L13.0582 18.9022H14.9447Z",
    fill: "#161616"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6232 6.15002L22.4988 8.78792L21.9519 11.4551L22.3413 11.7568L21.8144 12.1605L22.2104 12.4676L21.686 12.9471L22.008 13.1813L21.1536 14.1833L17.6494 13.1587L17.619 13.1423L15.0938 11.0032L21.6232 6.15002Z",
    fill: "#763E1A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37563 6.15002L12.9051 11.0032L10.3798 13.1423L10.3495 13.1587L6.84517 14.1833L5.99082 13.1813L6.3125 12.9473L5.78837 12.4676L6.18362 12.1608L5.64884 11.7559L6.05292 11.4541L5.5 8.78802L6.37563 6.15002Z",
    fill: "#763E1A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4794 12.9346L21.1924 14.0201L22.3987 17.7535L19.2162 17.7535L17.0234 17.7813L18.6181 14.6599L17.4794 12.9346Z",
    fill: "#F5841F"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5219 12.9346L9.383 14.6599L10.9779 17.7813L8.78617 17.7535H5.60938L6.8089 14.0201L10.5219 12.9346Z",
    fill: "#F5841F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3479 8.20813L15.3094 11.0248L15.089 14.8299L15.0047 16.0226L14.998 19.0693H12.9984L12.9919 16.0283L12.9073 14.8289L12.6868 11.0248L11.6484 8.20813H16.3479Z",
    fill: "#F5841F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamaskCircle);
export default __webpack_public_path__ + "static/media/metamask-circle.eb702b88.svg";
export { ForwardRef as ReactComponent };